
import { Component, Prop, Mixins } from 'vue-property-decorator'
import CalendarProvider from '@/components/hoc/CalendarProvider.vue';
import Calendar from '../components/calendar/Calendar.vue';
import CalendarV2 from '../components/calendar/CalendarV2.vue';
import { CalendarMode, CalendarModeValues } from '../components/calendar/types/CalendarMode';
import * as Routes from '@/../types/constants/web_client_user.routes';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';
import { VCalendarDay } from '@/components/calendar/types/VCalendarDay';
import { VueConstructor } from 'vue';
import { AppHostnameMixin, BAIconsMixin } from '@/mixins';

@Component({
	components: {
		CalendarProvider,
		CalendarV2,
		Calendar
	},
})
export default class FullScreenCalendar extends Mixins(AppHostnameMixin, BAIconsMixin){
	@Prop() teamId: string;
	@Prop({ default: false, type: Boolean }) athleteMode: boolean;
	types = CalendarModeValues;

	get IsMobile(): boolean{
		return this.$vuetify.breakpoint.xs;
	}

	calendarMode: CalendarMode = CalendarMode.Month;
	updateCalendarMode(mode: CalendarMode): void{
		this.calendarMode = mode;
	}

	addEvent({ focusDate }: { focusDate?: string }): void{
		if(this.AthleteAppActive) return;
		this.$router.push({
			name: Routes.TeamEventCreate,
			params:{
				...this.$route.params,
			},
			query:{
				focusDate,
				largeCalendar: 'true',
			}
		});
	}

	eventClicked({calendarEvent, $event}: {calendarEvent: CalendarEventModel, $event: VCalendarDay<CalendarEventModel>}): void{
		if(this.AthleteAppActive){
			this.$router.push({
				name: Routes.AthleteTeamEventView,
				params:{
					teamId: this.teamId,
					teamEventId: calendarEvent.id,
				},
				query: {
					focusDate: new Date($event.day.date.replace('-', ' ')).toISOString(),
					largeCalendar: 'true',
				}
			});
		}else{
			this.$router.push({
				name: Routes.TeamEventEdit,
				params:{
					teamId: this.teamId,
					teamEventId: calendarEvent.id,
				},
				query: {
					focusDate: new Date($event.day.date.replace('-', ' ')).toISOString(),
					largeCalendar: 'true',
				}
			});
		}
	}

	onCalendarCollapse() {
		if (this.AthleteAppActive){
			this.$router.push({
				name: Routes.AthleteTeamDashboardCalendar,
				params: { teamId: this.teamId },
			})
		} else {
			this.$router.push({
				name: Routes.TeamDashboardCalendar,
				params: { teamId: this.teamId },
			})
		}
		this.$emit('collapse:Calendar');
	}
	backToTeamDashboard(): void{
		if (this.AthleteAppActive){
			this.$router.push({
				name: Routes.AthleteTeamDashboardCalendar,
				params: { teamId: this.teamId },
			})
		} else {
			this.$router.push({
				name: Routes.TeamDashboardCalendar,
				params: { teamId: this.teamId },
			})
		}
	}
}
